import { Navigate, Route, Routes } from 'react-router-dom';
import { AppointmentRespond } from './pages/Appointment-Respond';
import { SingleVideo } from './pages/Single-Video';

const Router = () => {
	return (
		<Routes>
			<Route index path={`/:videoEntranceToken`} element={<SingleVideo />} />
			<Route path={'/appointments/respond'} element={<AppointmentRespond />} />
			<Route path='*' element={<Navigate to={'/:videoEntranceToken'} />} />
		</Routes>
	);
};

export default Router;
